import { render } from "./ExitDeclarationStatusFieldsetGroup.vue?vue&type=template&id=2558ee9a"
import script from "./ExitDeclarationStatusFieldsetGroup.vue?vue&type=script&lang=js"
export * from "./ExitDeclarationStatusFieldsetGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__